export const NPS_DETAIL_REPORT = 'NPS Detail Report V4';
export const NPS_DETAIL_REPORT_MESSAGE =
  'Provides a detailed list of the ActiveWeb NPS services responses for a chosen NPS category';
export const NPS_DETAIL_REPORT_TITLE = "NPSDetailReport04"

export const columns = [
  { name: 'name', title: 'Name', width: '150' },
  { name: 'siteCode', title: 'Site Code' },
  { name: 'schemeCode', title: 'Scheme Code' },
  { name: 'regmark', title: 'Regmark' },
  { name: 'claimReference', title: 'Claim Reference' },
  { name: 'claimId', title: 'Claim Id' },
  { name: 'surveyDate', title: 'Survey Date', type: 'date' },
  { name: 'responseDate', title: 'Response Date', type: 'date' },
  { name: 'response', title: 'Response', width: '150' },
  { name: 'score', title: 'Score', type: 'number' },
  { name: 'responseText', title: 'Response Text' },
  { name: 'repairerGroup', title: 'Repairer Group', width: '150' },
];

export const nPSScoreOptions = [
  { id: 0, value: 'Detractor', text: 'Detractor' },
  { id: 1, value: 'Promoter', text: 'Promoter' },
  { id: 2, value: 'Passive', text: 'Passive' },
  { id: 3, value: 'All Responses', text: 'All Responses' },
  { id: 4, value: 'All Surveys', text: 'All Surveys' },
];

